export function devOrProd(devValue, prodValue) {
  return process.env.VUE_APP_RUN_ENV === 'production' ? prodValue : devValue
}
